
const checkValidPhoneNumber = (value) => {
  const regEx = new RegExp(/\+?\d{1,4}?[-.\s]?\(?\d{1,3}?\)?[-.\s]?\d{1,4}[-.\s]?\d{1,4}[-.\s]?\d{1,9}/g)
  if (regEx.test(value)) {
    return true
  } else {
    return false
  }
}
export default checkValidPhoneNumber
